import { render, staticRenderFns } from "./v-checkbox-etra.vue?vue&type=template&id=43877b24&scoped=true&"
import script from "./v-checkbox-etra.vue?vue&type=script&lang=js&"
export * from "./v-checkbox-etra.vue?vue&type=script&lang=js&"
import style0 from "./v-checkbox-etra.vue?vue&type=style&index=0&id=43877b24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43877b24",
  null
  
)

export default component.exports